var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "span",
        {
          on: {
            click: function($event) {
              _vm.dialog = !_vm.dialog
            }
          }
        },
        [_vm._t("default")],
        2
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "690px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "pb-0" },
                [
                  !_vm.loaded
                    ? _c(
                        "v-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { cols: "12" }
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              color: "primary",
                              size: "105"
                            }
                          }),
                          _c("h3", { staticClass: "mt-4" }, [
                            _vm._v(_vm._s(_vm.$t("global.loading")))
                          ])
                        ],
                        1
                      )
                    : _c(
                        "v-col",
                        { staticClass: "pb-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "fieldset",
                            { staticClass: "custom-fieldset" },
                            [
                              _c("legend", [
                                _vm._v(
                                  _vm._s(_vm.$t("travelService.outdatedOffer"))
                                )
                              ]),
                              _c(
                                "v-row",
                                [
                                  _vm.model.html != null &&
                                  _vm.model.html.length !== 0
                                    ? _c(
                                        "v-col",
                                        { attrs: { md: "9" } },
                                        [
                                          _c("w-y-s-i-w-y-g-html-element", {
                                            attrs: { html: _vm.model.html }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.type === "hotel" &&
                                  (_vm.model.html == null ||
                                    _vm.model.html.length === 0)
                                    ? _c(
                                        "v-col",
                                        { attrs: { md: "9", cols: "12" } },
                                        [
                                          _c("hotel-response-presentation", {
                                            attrs: { offer: _vm.model }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.type === "car" &&
                                  (_vm.model.html == null ||
                                    _vm.model.html.length === 0)
                                    ? _c(
                                        "v-col",
                                        { attrs: { md: "9", cols: "12" } },
                                        [
                                          _c("car-response-presentation", {
                                            attrs: { offer: _vm.model }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.type === "flight" &&
                                  (_vm.model.html == null ||
                                    _vm.model.html.length === 0)
                                    ? _c(
                                        "v-col",
                                        { attrs: { md: "9", cols: "12" } },
                                        [
                                          _c("flight-response-presentation", {
                                            attrs: { offer: _vm.model }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.type === "rail" &&
                                  (_vm.model.html == null ||
                                    _vm.model.html.length === 0)
                                    ? _c(
                                        "v-col",
                                        { attrs: { md: "9", cols: "12" } },
                                        [
                                          _c("rail-response-presentation", {
                                            attrs: { offer: _vm.model }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pl-3",
                                      attrs: { md: "3", cols: "12" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t("global.amount"),
                                          value:
                                            _vm.model.price +
                                            " " +
                                            _vm.model.currency,
                                          outlined: "",
                                          readonly: ""
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-center my-3",
                                          staticStyle: { width: "100%" }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "font-size": "100px"
                                              },
                                              attrs: { color: "primary" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.bookingIconType(_vm.type)
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }